// Side bar de la page  Entreprise Dashboard

import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { 
  Home,
  Users,
  Settings,
  ChevronLeft,
  ChevronRight
} from 'lucide-react';
import { useTheme } from './ThemeContext';
import { NavigationItem } from './Ttype';
import {LifeBuoy} from 'lucide-react';

interface SidebarProps {
  customNavigation?: NavigationItem[];
}

export const Sidebar: React.FC<SidebarProps> = ({ customNavigation }) => {
  const { darkMode } = useTheme();
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  // Détection automatique mobile et gestion responsive
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth < 768) setIsCollapsed(true);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const defaultNavigation: NavigationItem[] = [
    { name: 'HomeAdmin', path: '/HomeAdmin', icon: Home },
    { name: 'Applications', path: '/EntrepriseDashboard', icon: Users },
    { name: 'Administrator', path: '/AdminPage', icon: Users },
    { name: 'Support', path: '/Support', icon: LifeBuoy },
    { name: 'Settings', path: '/settings', icon: Settings },
  ];

  const navigation = customNavigation || defaultNavigation;

  return (
    <div className={`fixed left-0 h-screen flex flex-col ${
      darkMode 
        ? 'bg-gray-900 text-gray-100 border-gray-700' 
        : 'bg-white text-gray-700 border-gray-200'
    } border-r transition-all duration-300 ease-in-out ${
      isCollapsed ? 'w-16 md:w-20' : 'w-64'
    } ${isMobile ? 'z-50' : 'z-20'}`}>
      
      {/* Header avec bouton de toggle amélioré */}
      <div className={`flex items-center ${
        isCollapsed ? 'justify-center' : 'justify-between'
      } p-4 border-b ${
        darkMode ? 'border-gray-700' : 'border-gray-200'
      }`}>
        {!isCollapsed && (
          <h2 className="text-lg font-semibold truncate">
            Menu
          </h2>
        )}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className={`p-1.5 rounded-full ${
            darkMode 
              ? 'hover:bg-gray-700 text-gray-300' 
              : 'hover:bg-gray-100 text-gray-500'
          } transition-colors`}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? (
            <ChevronRight className="h-5 w-5" />
          ) : (
            <ChevronLeft className="h-5 w-5" />
          )}
        </button>
      </div>

      {/* Navigation avec icônes et tooltips */}
      <nav className="flex-1 overflow-y-auto py-2">
        {navigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            className={({ isActive }) =>
              `group flex items-center mx-2 my-1 p-3 rounded-lg transition-colors ${
                isActive
                  ? darkMode 
                    ? 'bg-gray-800 text-white' 
                    : 'bg-indigo-50 text-red-400'
                  : darkMode
                    ? 'hover:bg-gray-800 text-gray-300'
                    : 'hover:bg-gray-100 text-gray-600'
              } ${
                isCollapsed ? 'justify-center' : 'justify-start'
              }`
            }
          >
            <item.icon className={`flex-shrink-0 h-5 w-5 ${
              isCollapsed ? '' : 'mr-3'
            }`} />
            
            {!isCollapsed ? (
              <span className="text-sm font-medium truncate">
                {item.name}
              </span>
            ) : (
              <div className={`absolute left-full ml-2 px-2 py-1 ${
                darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'
              } text-xs rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity z-50`}>
                {item.name}
              </div>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Version mobile - overlay */}
      {isMobile && !isCollapsed && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsCollapsed(true)}
        />
      )}
    </div>
  );
};

export default Sidebar;

// // components/Sidebar.tsx
// import React, { useState } from 'react';
// import { NavLink,} from 'react-router-dom';
// import { 
//   Menu,
//   X,

//   Users,
//   Settings,
//   Home,
// } from 'lucide-react';
// import { useTheme } from './ThemeContext';
// import { NavigationItem } from './Ttype';



// interface SidebarProps {
//   customNavigation?: NavigationItem[];
// }

// export const Sidebar: React.FC<SidebarProps> = ({ 
//   customNavigation 
// }) => {
//   const { darkMode } = useTheme();
//   const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

//   const defaultNavigation: NavigationItem[] = [
//     { name: 'Home', path: '/', icon: Home },
//     { name: 'Applications', path: '/EntrepriseDashboard', icon:Users },
  
//     { name: 'Administrator', path: '/AdminPage', icon: Users },
//     { name: 'Setting', path: `/settings`, icon: Settings },
//   ];

//   const navigation = customNavigation || defaultNavigation;

//   return (
//     <div className={`fixed left-0 h-screen ${
//       darkMode 
//         ? 'bg-gray-900 text-white border-gray-800' 
//         : 'bg-white text-gray-800 border-gray-200'
//     } border-r ${
      
//       isCollapsed ? 'w-20' : 'w-64'
//     } transition-all duration-300 ease-in-out pt-16`}>
//       <button
//         onClick={() => setIsCollapsed(!isCollapsed)}
//         className={`absolute right-0 top-20 transform translate-x-1/2 rounded-full p-2 ${
//           darkMode ? 'bg-gray-800' : 'bg-white'
//         } border ${
//           darkMode ? 'border-gray-700' : 'border-gray-200'
//         } shadow-lg`}
//         aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
//       >
//         {isCollapsed ? (
//           <Menu className="h-4 w-4" />
//         ) : (
//           <X className="h-4 w-4" />
//         )}
//       </button>

//       <div className="py-4">
//         {navigation.map((item) => (
//           <NavLink
//             key={item.name}
//             to={item.path}
//             className={({ isActive }) =>
//               `flex items-center px-4 py-2 mx-2 rounded-lg transition-colors ${
//                 isActive
//                   ? 'bg-indigo-600 text-white'
//                   : `text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 ${
//                       darkMode ? 'hover:text-white' : 'hover:text-gray-900'
//                     }`
//               }`
//             }
//           >
//             <item.icon className={`h-5 w-5 ${isCollapsed ? 'mx-auto' : 'mr-3'}`} />
//             {!isCollapsed && <span>{item.name}</span>}
//           </NavLink>
//         ))}
//       </div>
//     </div>
//   );
// };
// export default Sidebar;
